import { useMemo } from 'react';

import { EMPTY_STRING } from '@e-socna/empty';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import type { UserFormValues } from '../types/user-form-values.type';

export const useInitialValuesFactory = (isInternal: boolean) => {
  const { userRolesCodeMap } = useReferencesContext();

  const initialValues = useMemo<UserFormValues>(
    () => ({
      __typename: 'User',
      _id: EMPTY_ID,
      isInternal,
      personId: EMPTY_ID,
      email: EMPTY_STRING,
      globalRoleIds: [
        isInternal
          ? userRolesCodeMap.Internal._id
          : userRolesCodeMap.External._id,
      ],
    }),
    [isInternal, userRolesCodeMap],
  );

  return { initialValues };
};
